import React from 'react';
import {Link as MuiLink} from '@mui/material';
import type {LinkOwnProps} from '@mui/material/Link/Link';
import type {LinkProps as RouterLinkProps} from 'react-router';
import {Link as RouterLink} from 'react-router';
import type {TextVariant} from 'theme/types';
import type {TextProps} from '../text/types';
import {Text} from '../text';

type Props = Partial<
  Pick<TextProps, 'textTransform' | 'variant' | 'mode' | 'kind'>
> &
  Pick<RouterLinkProps, 'to' | 'className' | 'onClick'> & {
    title: string;
    sx?: LinkOwnProps['sx'];
    children?: React.ReactNode;
  };
export const Link: React.FC<Props> = ({
  to,
  sx,
  title,
  textTransform,
  variant,
  mode,
  kind,
  onClick,
  children,
}) => {
  const variantWithDefault: TextVariant = variant ? variant : 'body1';

  return (
    <MuiLink component={RouterLink} to={to} sx={sx} onClick={onClick}>
      {children ? (
        children
      ) : (
        <Text
          variant={variantWithDefault}
          component={'span'}
          textTransform={textTransform}
          kind={kind}
          mode={mode}>
          {title}
        </Text>
      )}
    </MuiLink>
  );
};
